module.exports = __webpack_public_path__ + "assets/img/support.bc3de1b3.png";